export const COMPARISON_CONSTANTS = {
  title: "Internet & Interconnect Comparison: Traditional vs OneMind",
  desc: "OneMind delivers high-performance, carrier-neutral connectivity that's fast, secure, and built for the cloud era — unlike traditional internet services that compromise on speed, flexibility, and visibility.",
  items: [
    {
      title: "The Old Way",
      subTitle: "Traditional Internet & Interconnect",
      points: [
        "Single ISP dependency with no route diversity",
        "Manual provisioning, long setup times",
        "No performance SLA or uptime guarantee",
        "Vendor lock-in and limited flexibility",
        "No integrated monitoring or visibility",
        "Unpredictable pricing and overages",
      ],
    },
    {
      title: "The New Way",
      subTitle: "OneMind Internet & DCI",
      points: [
        "Carrier-neutral design with multiple ISPs for redundancy",
        "Fast deployment via fully managed provisioning",
        "Guaranteed SLA-backed performance and uptime",
        "No vendor lock-in — fully open, flexible architecture",
        "Built-in real-time observability and diagnostics",
        "Flat-rate billing with transparent service plans",
      ],
    },
  ],
};
